<div class="background">
  <div class="jumbotron jumbotron-fluid">
    <div class="container">
      <p class="h2">Has sortit de l'aplicació</p>
      
      <hr class="my-4">
      <p class="center">
        <a class="btn btn-primary btn-lg" href="/" role="button">Home</a>
      </p>

    </div>
  </div>
</div>
